import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Search.svg",
  "use": "Search.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Search.svg\"><path d=\"M29.01,10.0209A18.9741,18.9741,0,0,1,44.258,40.3225l10.2571,8.6757a3.9206,3.9206,0,1,1-5.5273,5.5273L40.31,44.27a18.9914,18.9914,0,1,1-11.3-34.2491Zm0,34a15,15,0,1,0-15-15A15,15,0,0,0,29.01,44.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol